/* Portionsrechner und "Alle Zutaten in den Warenkorb".
   Beides ist Fortschrittserweiterung: ohne JavaScript bleiben die Mengen
   auf der Grundportion stehen und jede Zutat hat weiterhin ihren eigenen
   Warenkorb-Button, der als normales Formular funktioniert. */
(function () {
  var NUM = /^(\d+(?:[.,]\d+)?)(\s+)(.+)$/;

  function fmt(n) {
    var r = Math.round(n * 100) / 100;
    var s = r.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    return s.replace('.', ',');
  }

  function parseNum(s) {
    return parseFloat(String(s).replace(',', '.'));
  }

  /* ---------- Portionen ---------- */
  function initServings(root) {
    var out = root.querySelector('[data-servings-value]');
    var dec = root.querySelector('[data-servings-step="-1"]');
    var inc = root.querySelector('[data-servings-step="1"]');
    var labels = Array.prototype.slice.call(root.querySelectorAll('[data-base-label]'));
    if (!out || !dec || !inc) return;

    var base = parseInt(out.dataset.base, 10) || 1;
    var min = parseInt(out.dataset.min, 10) || 1;
    var max = parseInt(out.dataset.max, 10) || 20;
    var current = base;

    function render() {
      var word = current === 1 ? out.dataset.singular : out.dataset.plural;
      out.textContent = current + ' ' + word;
      dec.disabled = current <= min;
      inc.disabled = current >= max;

      var factor = current / base;
      labels.forEach(function (el) {
        var label = el.dataset.baseLabel;
        var m = NUM.exec(label);
        if (!m) { el.textContent = label; return; }
        el.textContent = fmt(parseNum(m[1]) * factor) + m[2] + m[3];
      });
    }

    dec.addEventListener('click', function () { if (current > min) { current--; render(); } });
    inc.addEventListener('click', function () { if (current < max) { current++; render(); } });
    render();
  }

  /* ---------- Alle Zutaten in den Warenkorb ---------- */
  function initAddAll(root) {
    var btn = root.querySelector('[data-add-all]');
    if (!btn) return;

    var ids = (btn.dataset.addAll || '').split(',').filter(Boolean);
    if (!ids.length) return;

    var status = root.querySelector('[data-add-all-status]');
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Ohne JavaScript bleibt der Button verborgen, weil er sonst nichts tun wuerde.
    btn.hidden = false;

    function say(msg, isError) {
      if (!status) return;
      status.textContent = msg;
      status.hidden = false;
      status.classList.toggle('recipe__addall-status--error', !!isError);
    }

    function refreshBubble() {
      fetch(rootUrl + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-icon-bubble'];
          var target = document.getElementById('cart-icon-bubble');
          if (!html || !target) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#cart-icon-bubble');
          if (fresh) target.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* die Zahl im Header bleibt eben stehen */ });
    }

    btn.addEventListener('click', function () {
      btn.disabled = true;
      say(btn.dataset.busy || '…');

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function () {
          say((btn.dataset.done || '').replace('[n]', ids.length));
          refreshBubble();
        })
        .catch(function () {
          say(btn.dataset.error || 'Das hat nicht geklappt.', true);
        })
        .then(function () { btn.disabled = false; });
    });
  }

  function boot() {
    document.querySelectorAll('[data-recipe-tools]').forEach(function (root) {
      if (root.dataset.rwToolsReady === '1') return;
      root.dataset.rwToolsReady = '1';
      initServings(root);
      initAddAll(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
